<template>
  <div id="enterprise">
    <div class="enterprise-title">
      <template v-if="enterpriseInfo.intro && enterpriseInfo.base">
        <div class="base_header">
          <div class="base_header_left">
            <div
              class="base_header_left_logo"
              v-if="enterpriseInfo.intro && enterpriseInfo.intro.logo"
            >
              <img :src="enterpriseInfo.intro.logo" alt="" />
            </div>
            <div
              class="base_header_left_logo"
              v-else-if="enterpriseInfo.base && enterpriseInfo.base.entname"
            >
              <!-- 截取前两个字符 -->
              <div>
                {{
                  enterpriseInfo.base
                    ? enterpriseInfo.base.entname.slice(0, 2)
                    : "--"
                }}
              </div>
              <div>
                {{
                  enterpriseInfo.base
                    ? enterpriseInfo.base.entname.slice(2, 4)
                    : "--"
                }}
              </div>
            </div>
            <div class="base_header_left_text">
              <div class="company_name">
                <span>{{
                  enterpriseInfo.base ? enterpriseInfo.base.entname : "--"
                }}</span>
                <div class="invoice" @click="drawerOper('invoice')">
                  <img
                    src="https://51nbimg.u51.com/0ffdd1199ebf477baa51590ab0b89807.png"
                    alt=""
                  />
                  <span>发票抬头</span>
                </div>
                <div
                  class="invoice"
                  @click="drawerOper('client')"
                  v-if="clientAllFunctionModels.clientInfo == '1' && client.id"
                >
                  <i class="el-icon-user"></i>
                  <span>客户设置</span>
                </div>
                <div
                  class="invoice"
                  @click="drawerOper('contract')"
                  v-if="
                    contractAllFunctionModels.contractInfo == '1' && client.id
                  "
                >
                  <i class="el-icon-tickets"></i>
                  <span>合同查询</span>
                </div>
              </div>
              <div class="company_tags"></div>
            </div>
          </div>
          <div class="base_header_right">
            <el-badge :value="badge">
              <el-popover
                ref="relevancePopover"
                placement="bottom"
                width="960"
                trigger="click"
              >
                <el-table :data="gridData" height="40vh" size="mini">
                  <el-table-column label="公司名称" min-width="180">
                    <template slot-scope="scope">
                      <div>{{ scope.row.clientName || scope.row.name }}</div>
                      <div
                        v-if="
                          scope.row.clientFullName &&
                          scope.row.clientFullName !==
                            (scope.row.clientName || scope.row.name)
                        "
                        style="color: #909399; font-size: 12px; line-height: 16px"
                      >
                        {{ scope.row.clientFullName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="关联方式" min-width="170">
                    <template slot-scope="scope">
                      <el-tag
                        v-for="(item, index) in getRelationTypeNames(scope.row)"
                        :key="index"
                        size="mini"
                        :type="relationTagType(index, scope.row)"
                        style="margin: 0 4px 2px 0"
                        >{{ item }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="关联内容" min-width="260">
                    <template slot-scope="scope">
                      <div
                        v-for="(item, index) in getRelationContents(scope.row)"
                        :key="index"
                        style="line-height: 18px"
                      >
                        {{ item }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="财税顾问" min-width="120">
                    <template slot-scope="scope">{{
                      formatConsultants(scope.row)
                    }}</template>
                  </el-table-column>
                  <el-table-column label="服务状态" min-width="140">
                    <template slot-scope="scope">
                      <el-tag
                        v-for="(item, index) in getStatusList(scope.row)"
                        :key="index"
                        size="mini"
                        :type="statusTagType(item)"
                        style="margin: 0 4px 2px 0"
                        >{{ item }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="90">
                    <template slot="header">
                      <div
                        class="base_header_right_client"
                        @click="addRelevanceClient"
                      >
                        操作
                        <i
                          style="cursor: pointer"
                          class="el-icon-circle-plus-outline"
                        ></i>
                      </div>
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        v-if="canRemoveRelevance(scope.row)"
                        type="text"
                        size="small"
                        style="color: #f56c6c"
                        @click="deleteRelevanceClient(scope.row.id)"
                        >解除</el-button
                      >
                      <span
                        v-else
                        style="color: #909399; font-size: 12px"
                        title="老板/经营关联由系统自动计算，不可手动解除"
                        >自动关联</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  slot="reference"
                  @click="showRelevanceClient"
                  >关联客户</el-button
                >
              </el-popover>
            </el-badge>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="base_header">
          <div class="base_header_left">
            <div class="base_header_left_logo">
              <!-- 截取前两个字符 -->
              <div>
                {{ clientInfo.clientName.slice(0, 2) }}
              </div>
              <div>
                {{ clientInfo.clientName.slice(2, 4) }}
              </div>
            </div>
            <div class="base_header_left_text">
              <div class="company_name">
                <span>{{ clientInfo.clientName }}</span>
                <div class="invoice" @click="drawerOper('invoice')">
                  <img
                    src="https://51nbimg.u51.com/0ffdd1199ebf477baa51590ab0b89807.png"
                    alt=""
                  />
                  <span>发票抬头</span>
                </div>
                <div
                  class="invoice"
                  @click="drawerOper('client')"
                  v-if="clientAllFunctionModels.clientInfo == '1' && client.id"
                >
                  <i class="el-icon-user"></i>
                  <span>客户设置</span>
                </div>
                <div
                  class="invoice"
                  @click="drawerOper('contract')"
                  v-if="
                    contractAllFunctionModels.contractInfo == '1' && client.id
                  "
                >
                  <i class="el-icon-tickets"></i>
                  <span>合同查询</span>
                </div>
              </div>
              <div class="company_tags">
                <el-tag
                  size="mini"
                  type="success"
                  style="margin-right: 5px"
                  v-for="(tag, index) in enterpriseInfo.mainTags"
                  :key="index"
                >
                  {{ tag }}</el-tag
                >
              </div>
            </div>
          </div>
          <div class="base_header_right">
            <el-badge :value="badge">
              <el-popover
                ref="relevancePopover"
                placement="bottom"
                width="960"
                trigger="click"
              >
                <el-table :data="gridData" height="40vh" size="mini">
                  <el-table-column label="公司名称" min-width="180">
                    <template slot-scope="scope">
                      <div>{{ scope.row.clientName || scope.row.name }}</div>
                      <div
                        v-if="
                          scope.row.clientFullName &&
                          scope.row.clientFullName !==
                            (scope.row.clientName || scope.row.name)
                        "
                        style="color: #909399; font-size: 12px; line-height: 16px"
                      >
                        {{ scope.row.clientFullName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="关联方式" min-width="170">
                    <template slot-scope="scope">
                      <el-tag
                        v-for="(item, index) in getRelationTypeNames(scope.row)"
                        :key="index"
                        size="mini"
                        :type="relationTagType(index, scope.row)"
                        style="margin: 0 4px 2px 0"
                        >{{ item }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="关联内容" min-width="260">
                    <template slot-scope="scope">
                      <div
                        v-for="(item, index) in getRelationContents(scope.row)"
                        :key="index"
                        style="line-height: 18px"
                      >
                        {{ item }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="财税顾问" min-width="120">
                    <template slot-scope="scope">{{
                      formatConsultants(scope.row)
                    }}</template>
                  </el-table-column>
                  <el-table-column label="服务状态" min-width="140">
                    <template slot-scope="scope">
                      <el-tag
                        v-for="(item, index) in getStatusList(scope.row)"
                        :key="index"
                        size="mini"
                        :type="statusTagType(item)"
                        style="margin: 0 4px 2px 0"
                        >{{ item }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="90">
                    <template slot="header">
                      <div
                        class="base_header_right_client"
                        @click="addRelevanceClient"
                      >
                        操作
                        <i
                          style="cursor: pointer"
                          class="el-icon-circle-plus-outline"
                        ></i>
                      </div>
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        v-if="canRemoveRelevance(scope.row)"
                        type="text"
                        size="small"
                        style="color: #f56c6c"
                        @click="deleteRelevanceClient(scope.row.id)"
                        >解除</el-button
                      >
                      <span
                        v-else
                        style="color: #909399; font-size: 12px"
                        title="老板/经营关联由系统自动计算，不可手动解除"
                        >自动关联</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  slot="reference"
                  @click="showRelevanceClient"
                  >关联客户</el-button
                >
              </el-popover>
            </el-badge>
          </div>
        </div>
      </template>
      <template>
        <div class="base_info">
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="base_info_item">
                  <span class="base_info_item_title">企业法人:</span>
                  <span
                    class="base_info_item_value activeColor"
                    v-if="enterpriseInfo.base"
                    >{{
                      enterpriseInfo.base ? enterpriseInfo.base.frname : "--"
                    }}
                    <!-- 判断 enterpriseInfo.personStatistics 不是空对象 -->
                    <span
                      v-if="
                        enterpriseInfo.personStatistics &&
                        enterpriseInfo.base.frPersonId
                      "
                      @click="drawerOper('companyList')"
                      class="activeColor"
                      style="font-size: 12px; margin-left: 5px"
                      >关联{{
                        enterpriseInfo.personStatistics[
                          enterpriseInfo.base.frPersonId
                        ]
                          ? enterpriseInfo.personStatistics[
                              enterpriseInfo.base.frPersonId
                            ].refCompanysCnt
                          : "--"
                      }}家公司</span
                    ></span
                  >
                  <span v-else>--</span>
                </div>
                <div class="base_info_item">
                  <span class="base_info_item_title">员工规模:</span>
                  <span class="base_info_item_value">{{
                    enterpriseInfo.base ? enterpriseInfo.base.staffNum : "--"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="base_info_item">
                  <span class="base_info_item_title">成立日期:</span>
                  <span class="base_info_item_value">{{
                    enterpriseInfo.base ? enterpriseInfo.base.esdate : "--"
                  }}</span>
                </div>
                <div class="base_info_item">
                  <span class="base_info_item_title">市值/估值:</span>
                  <span
                    class="base_info_item_value"
                    v-if="enterpriseInfo.capital"
                    >{{
                      enterpriseInfo.capital.valuationStr +
                        enterpriseInfo.capital.valuationCurStr || "--"
                    }}</span
                  >
                  <span v-else>--</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="base_info_item">
                  <span class="base_info_item_title">注册资本:</span>
                  <span
                    class="base_info_item_value"
                    v-if="enterpriseInfo.base"
                    >{{
                      enterpriseInfo.base.regcapStr +
                        enterpriseInfo.base.regCapCurName || "--"
                    }}</span
                  >
                  <span v-else>--</span>
                </div>
                <div class="base_info_item">
                  <span class="base_info_item_title">累计融资:</span>
                  <span class="base_info_item_value">{{
                    enterpriseInfo.intro ? enterpriseInfo.intro.finAmtStr : "--"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="base_info_item">
                  <span class="base_info_item_title">国标行业:</span>
                  <span class="base_info_item_value">{{
                    enterpriseInfo.base
                      ? enterpriseInfo.base.industryphyNameStr
                      : "--"
                  }}</span>
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <div class="base_info_item">
                <span class="base_info_item_title">企业官网:</span>
                <el-popover
                  placement="bottom-start"
                  trigger="hover"
                  v-if="
                    enterpriseInfo.webSites &&
                    enterpriseInfo.webSites.length > 0
                  "
                >
                  <div
                    v-for="(item, index) in enterpriseInfo.webSites"
                    :key="index"
                  >
                    <a
                      :href="item.openUrl"
                      style="color: #327bf9; text-decoration: none"
                      target="_blank"
                      >{{ item.openUrl }}
                    </a>
                  </div>
                  <span
                    slot="reference"
                    class="base_info_item_value activeColor"
                    @click="link(enterpriseInfo.webSites[0].openUrl)"
                    >{{ enterpriseInfo.webSites[0].openUrl || "--"
                    }}<span
                      class="activeColor"
                      style="margin-left: 5px"
                      v-if="enterpriseInfo.webSites.length > 1"
                      >({{ enterpriseInfo.webSites.length }})</span
                    >
                  </span>
                </el-popover>
                <span v-else>--</span>
              </div>
              <div class="base_info_item">
                <span class="base_info_item_title">公司地址:</span>
                <span class="base_info_item_value">{{
                  enterpriseInfo.clientInfo &&
                  enterpriseInfo.clientInfo.physicalAddress
                    ? `${enterpriseInfo.clientInfo.physicalAddress} (实际经营地)`
                    : enterpriseInfo.base
                    ? enterpriseInfo.base.addr
                    : "--"
                }}</span>
                <span
                  v-if="
                    enterpriseInfo.addrAgg && enterpriseInfo.addrAgg.length > 0
                  "
                  class="activeColor"
                  @click="drawerOper('addressList')"
                >
                  等{{ enterpriseInfo.addrAgg.length }}个</span
                >
              </div>
            </el-col>
          </el-row>
          <el-row>
            <div class="base_info_item" style="align-items: flex-start">
              <span class="base_info_item_title">客户标签:</span>
              <span
                class="base_info_item_value"
                style="flex-wrap: wrap"
                v-if="
                  enterpriseInfo.clientInfo &&
                  enterpriseInfo.clientInfo.tip.length > 0
                "
              >
                <span
                  class="tag"
                  v-for="(item, index) in enterpriseInfo.clientInfo.tip"
                  :key="index"
                  >{{ item }}</span
                >
              </span>
              <span v-else>--</span>
            </div>
            <div class="base_info_item">
              <span class="base_info_item_title">注意事项:</span>
              <span class="base_info_item_value">{{
                enterpriseInfo.individualNeeds
                  ? enterpriseInfo.individualNeeds[0].content
                  : "--"
              }}</span>
              <span
                v-if="
                  enterpriseInfo.individualNeeds &&
                  enterpriseInfo.individualNeeds.length > 0
                "
                class="activeColor"
                @click="drawerOper('individualNeeds')"
              >
                等{{ enterpriseInfo.individualNeeds.length }}个</span
              >
            </div>
          </el-row>
          <el-row v-if="enterpriseInfo.belongGroup">
            <div class="base_info_group">
              <div class="base_info_group_item">
                <span class="base_info_group_item_title">所属集团:</span>
                <span class="base_info_group_item_value">{{
                  enterpriseInfo.belongGroup.name
                }}</span>
              </div>
              <div class="base_info_group_item">
                <span class="base_info_group_item_title">集团主公司:</span>
                <!-- todo 点击跳转没做 -->
                <span
                  class="base_info_group_item_value activeColor"
                  @click="drawerOper('group')"
                  >{{ "--" }}</span
                >
              </div>
              <div class="base_info_group_item">
                <span class="base_info_group_item_title">集团成员:</span>
                <!-- todo 点击查询没做 -->
                <span class="base_info_group_item_value activeColor"
                  >{{ enterpriseInfo.belongGroup.cnt }}家</span
                >
              </div>
            </div>
          </el-row>
        </div>
      </template>
    </div>
    <div class="enterprise-schedule">
      <!-- 服务流程 -->
      <enterprise-step
        v-if="stepList.id"
        :clientInfo="clientInfo"
        :enterpriseInfo="enterpriseInfo"
        :stepList="stepList"
        @refreshClientData="refreshClientData"
      ></enterprise-step>
      <!-- 近期日程 -->
      <enterprise-schedule
        :clientInfo="clientInfo"
        :scheduleData="scheduleData"
        @getScheduleList="getScheduleList"
      ></enterprise-schedule>
    </div>
    <div class="enterprise-info">
      <div class="tabs-nav-list">
        <div class="tabs-nav-list-1">
          <el-tabs v-model="tab1.active" @tab-click="changeTab({}, 1)">
            <el-tab-pane
              :name="item.name"
              v-for="(item, index) in tab1.list"
              :key="index"
              :disabled="item.disabled"
            >
              <div slot="label" class="el-tab-pane">
                <div><img :src="item.icon" />{{ item.name }}</div>
                <div v-if="item.count">({{ item.count }})</div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div>
          <div class="tabs-nav-list-2" v-if="tab2.list && tab2.list.length > 0">
            <div
              :class="{
                'tabs-nav-list-2-item': true,
                'is-active': item.name === tab2.active,
                'is-disabled': item.disabled,
              }"
              v-for="(item, index) in tab2.list"
              :key="index"
              @click="changeTab(item, 2)"
            >
              {{ item.name }} <span>{{ item.count }}</span>
            </div>
          </div>
          <div class="tabs-nav-list-3" v-if="tab3.list && tab3.list.length > 0">
            <div
              :class="{
                'tabs-nav-list-3-item': true,
                'is-active': item.name === tab3.active,
                'is-disabled': item.disabled,
              }"
              v-for="(item, index) in tab3.list"
              :key="index"
              @click="changeTab(item, 3)"
            >
              {{ item.name }} <span>{{ item.count }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="enterprise-info-content">
        <!-- 企业信息 -->
        <enterpriseInformation
          v-if="tab1.active == '企业信息' && enterpriseInfo.base"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
          @entAnYears="entAnYears"
          @changeActiveCount="changeActiveCount"
        ></enterpriseInformation>
        <!-- 企业图谱 -->
        <enterpriseMap
          v-if="tab1.active == '企业图谱' && enterpriseInfo.base"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
        ></enterpriseMap>
        <!-- 经营信息 -->
        <managementInformation
          v-if="tab1.active == '经营信息' && enterpriseInfo.base"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
          @changeActiveCount="changeActiveCount"
        ></managementInformation>
        <!-- 联系方式 -->
        <enterpriseContact
          v-if="tab1.active == '联系方式'"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
          @changeActiveCount="changeActiveCount"
        ></enterpriseContact>
        <!-- 档案 -->
        <enterpriseArchives
          v-if="tab1.active == '档案'"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
        ></enterpriseArchives>
        <!-- 云盘 -->
        <enterpriseCloud
          v-if="tab1.active == '云盘'"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
        ></enterpriseCloud>
        <!-- 服务 -->
        <enterpriseServe
          v-if="tab1.active == '服务'"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
        ></enterpriseServe>
        <!-- 证据链 -->
        <enterpriseEvidence
          v-if="tab1.active == '证据链'"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :department="department"
          :userIds="userIds"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
        ></enterpriseEvidence>
        <!-- 发票 -->
        <enterpriseInvoice
          v-if="tab1.active == '发票'"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
        ></enterpriseInvoice>
        <!-- 报表 -->
        <enterpriseStatement
          v-if="tab1.active == '报表'"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
        ></enterpriseStatement>
        <!-- 预算表 -->
        <enterpriseBudget
          v-if="tab1.active == '预算表'"
          :clientInfo="clientInfo"
          :enterpriseInfo="enterpriseInfo"
          :tabActive="{ tab2Active: tab2.active, tab3Active: tab3.active }"
        ></enterpriseBudget>
      </div>
    </div>
    <!-- 弹出框 -->
    <div id="my-dialog" v-if="dialogData.flag">
      <my_dialog
        :width="dialogData.width"
        :title="dialogData.title"
        :buttonArray="dialogData.buttonArray"
        :data="dialogData.data"
        @colseDialog="colseDialog"
        @dialogOper="drawerOper"
        @buttonOper="drawerOper"
        @pageChange="pageChange"
        @remoteMethod2="remoteMethod2"
      ></my_dialog>
    </div>
  </div>
</template>

<script>
import * as allClientData from "@/views/client/js/clientData.js";
import enterpriseInformation from "@/components/enterprise-components/enterprise-information";
import managementInformation from "@/components/enterprise-components/management-information";
import enterpriseContact from "@/components/enterprise-components/enterprise-contact";
import enterpriseMap from "@/components/enterprise-components/enterprise-map";
import enterpriseArchives from "@/components/enterprise-components/enterprise-archives";
import enterpriseCloud from "@/components/enterprise-components/enterprise-cloud";
import enterpriseServe from "@/components/enterprise-components/enterprise-serve";
import enterpriseStep from "@/components/enterprise-components/enterprise-step.vue";
import enterpriseSchedule from "@/components/enterprise-components/enterprise-schedule.vue";
import enterpriseEvidence from "@/components/enterprise-components/enterprise-evidence.vue";
import enterpriseInvoice from "@/components/enterprise-components/enterprise-invoice.vue";

import { getClientByQuery } from "@/minixs.js";
export default {
  components: {
    enterpriseInformation,
    managementInformation,
    enterpriseContact,
    enterpriseMap,
    enterpriseArchives,
    enterpriseCloud,
    enterpriseServe,
    enterpriseStep,
    enterpriseSchedule,
    enterpriseEvidence,
    enterpriseInvoice,
    enterpriseStatement: () =>
      import("@/components/enterprise-components/enterprise-statement.vue"),
    enterpriseBudget: () =>
      import("@/components/enterprise-components/enterprise-budget.vue"),
    my_dialog: () => import("@/components/dialog.vue"),
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: "client",
    },
    department: {
      type: String,
      default: "",
    },
    userIds: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    clientInfo: {
      handler(newVal, oldVal) {
        this.clientInfo = newVal;
      },
      deep: true,
    },
  },
  mixins: [getClientByQuery],
  data() {
    return {
      baseInfo: {},
      client: {},
      dialogData: {
        flag: false,
        width: "45%",
        title: "新建报销",
        buttonArray: [
          {
            text: "提交",
            active: "submit_gnjinjilu",
          },
        ],
        data: [],
      },
      tab1: {},
      tab2: {},
      tab3: {},
      tabList: [],
      enterpriseInfo: {},
      clientAllFunctionModels: {},
      contractAllFunctionModels: {},
      stepList: {},
      scheduleData: {
        date: [],
        list: [],
      },
      gridData: [],
      badge: 0,
    };
  },
  methods: {
    /**
     * 获取初始菜单设置的按钮权限
     */
    getUserAuthorityByModels() {
      let requestData = {
        userId: this.baseInfo.userId,
        model: ["clientInfo"],
        companyId: this.baseInfo.company.companyId,
      };
      this.$request(
        "post",
        "/featureRoleRel/getUserAuthorityByModels",
        requestData,
        (data) => {
          this.clientAllFunctionModels = data;
          let requestData2 = {
            userId: this.baseInfo.userId,
            model: ["contractInfo"],
            companyId: this.baseInfo.company.companyId,
          };
          this.$request(
            "post",
            "/featureRoleRel/getUserAuthorityByModels",
            requestData2,
            (data2) => {
              this.contractAllFunctionModels = data2;
              console.log(
                "this.contractAllFunctionModels",
                this.contractAllFunctionModels,
              );
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    scrollToTop() {
      const el = document.querySelector(".enterprise-info");
      if (el) {
        this.$nextTick(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }
    },
    changeTab(item, flag) {
      if (item.disabled) return;
      switch (flag) {
        case 1:
          this.tab2 = allClientData.enterpriseTabList(this.tab1.active);
          this.getOtherTab();
          this.scrollToTop();
          break;
        case 2:
          this.tab2.active = item.name;
          this.getOtherTab();
          this.scrollToTop();
          break;
        case 3:
          // 三级 tab
          this.tab3.active = item.name;
          break;
        default:
          break;
      }
    },
    getOtherTab() {
      if (this.tab2.list.length > 0) {
        this.tab2.list.forEach((item) => {
          if (item.name == this.tab2.active) {
            this.tab3 = item.children
              ? JSON.parse(JSON.stringify(item.children))
              : {};
          }
        });
      } else {
        this.tab3 = {};
      }
    },
    // 获取企业基本信息
    getBaseInfo() {
      // 优先使用企业税号, 无税号使用企业名称 企业名称长度大于5个字符时使用企业名称
      let uscc = "";
      if (this.client.enterpriseNumber) {
        uscc = this.client.enterpriseNumber;
      } else if (this.client.clientName.length > 5) {
        uscc = this.client.clientName;
      }
      this.$request(
        "get",
        "/xiaoLanBen/queryBaseEntInfo?uscc=" + uscc, // "阿里巴巴（中国）网络技术有限公司"
        {},
        (data) => {
          if (data) {
            this.enterpriseInfo = data;
            this.enterpriseInfo.base.industryphyNameStr = `${
              this.enterpriseInfo.base.industryphyName || "--"
            }>${this.enterpriseInfo.base.industryphy1Name || "--"}>${
              this.enterpriseInfo.base.industryphy2Name || "--"
            }>${this.enterpriseInfo.base.industrycoNameOrg || "--"}`;
          }
          // 有客户id clientInfo 才获取企业注意事项和crm客户信息
          if (this.client.id) {
            this.refreshClientData();
          }
        },
        (errorMessage) => {
          this.$message.error(
            "未查询到企业信息，请点击客户设置完善企业税号或企业名称后重试",
          );
          // 有客户id clientInfo 才获取企业注意事项和crm客户信息
          if (this.client.id) {
            this.refreshClientData();
          }
        },
      );
    },
    // 获取企业注意事项
    getIndividualNeeds() {
      this.$request(
        "get",
        "/clientDemand/queryListByClientId?clientId=" + this.client.id,
        {},
        (data2) => {
          this.$set(this.enterpriseInfo, "individualNeeds", data2);
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    getClientInfo() {
      let requestData = {
        authorityData: [
          "tip",
          "physicalAddress",
          "clientNum",
          "enterpriseNumber",
          "bankName",
          "bankAccount",
          "physicalAddress",
          "isInvoicing",
          "isSocialSecurity",
          "isStatement",
          "isTaxPark",
          "isBookbinding",
          "isFinancialData",
          "isSuitableClient",
          "wechatGroupId",
          "wechatGroupName",
        ],
        clientId: this.client.id,
        companyId: this.baseInfo.company.companyId,
        userId: this.baseInfo.userId,
      };
      this.$request(
        "post",
        "/client/showClientInfoByID",
        requestData,
        (data) => {
          this.$set(this.enterpriseInfo, "clientInfo", data.data);
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 获取日程模板实例
    getServiceTemplateInstance() {
      this.$request(
        "get",
        "/serviceTemplateInstance/showDetailByClientId?clientId=" +
          this.clientInfo.id,
        {},
        async (data) => {
          this.stepList = data;
        },
        (errorMessage) => {
          // this.$message.error(errorMessage);
        },
      );
    },
    // 获取客户日程
    getScheduleList() {
      console.log("this.scheduleData.date[0]", this.scheduleData.date[0]);
      let requestData = {
        clientId: this.client.id,
        startMonth: this.scheduleData.date[0],
        endMonth: this.scheduleData.date[1],
      };
      this.$request(
        "post",
        `/schedule/queryListByClientId`,
        requestData,
        (data) => {
          this.scheduleData.list = data;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    drawerOper(active) {
      let requestData = {};
      switch (active) {
        // 企业发票抬头
        case "invoice":
          this.dialogData.width = "500px";
          this.dialogData.title = "发票抬头";
          this.dialogData.buttonArray = [
            {
              text: "一键复制",
              active: "copy",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.$request(
            "get",
            "/xiaoLanBen/api_1630?eid=" + this.enterpriseInfo.base.eid,
            {},
            (data) => {
              this.dialogData.data = [
                {
                  type: "text",
                  title: "企业名称",
                  value: data.entInfo.invoiceOrDefault.name || "--",
                },
                {
                  type: "text",
                  title: "企业税号",
                  value: data.entInfo.invoiceOrDefault.taxNo || "--",
                },
                {
                  type: "text",
                  title: "企业地址",
                  value: data.entInfo.invoiceOrDefault.addr || "--",
                },
                {
                  type: "text",
                  title: "企业电话",
                  value: data.entInfo.invoiceOrDefault.phone || "--",
                },
                {
                  type: "text",
                  title: "开户银行",
                  value: data.entInfo.invoiceOrDefault.bank || "--",
                },
                {
                  type: "text",
                  title: "银行账户",
                  value: data.entInfo.invoiceOrDefault.bankAccount || "--",
                },
              ];
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          this.dialogData.flag = true;
          break;
        // 一键复制企业发票信息
        case "copy":
          let copyInput = document.createElement("textarea"); // 创建标签 想要复制生成换行效果， 必须要使用 textarea
          copyInput.value = `企业名称：${this.dialogData.data[0].value}\n\n企业税号：${this.dialogData.data[1].value}\n\n企业地址：${this.dialogData.data[2].value}\n\n企业电话：${this.dialogData.data[3].value}\n\n开户银行：${this.dialogData.data[4].value}\n\n银行账户：${this.dialogData.data[5].value}`; // 标签赋值
          document.body.appendChild(copyInput); // 添加标签
          copyInput.select(); // 选取文本框内容
          document.execCommand("copy"); // 调用浏览器复制
          document.body.removeChild(copyInput); // 复制成功后再将构造的标签 移除
          this.$message.success("复制成功");
          this.dialogData.flag = false;
          break;
        // 查看企业关联公司
        case "companyList":
          this.dialogData.width = "800px";
          this.dialogData.title = this.enterpriseInfo.base.frname + "关联公司";
          this.dialogData.buttonArray = [];
          let pageData = {
            pageIndex: 1,
            pageSize: 10,
          };
          this.getCompanyList(pageData);
          break;
        // 查看企业地址列表
        case "addressList":
          this.dialogData.width = "500px";
          this.dialogData.title = `公司地址(${this.enterpriseInfo.addrAgg.length})`;
          this.dialogData.buttonArray = [];
          this.dialogData.data = [
            {
              type: "address-list",
              title: "",
              data: this.enterpriseInfo.addrAgg,
            },
          ];
          this.dialogData.flag = true;
          break;
        case "individualNeeds":
          // 查看企业个性需求
          this.dialogData.width = "500px";
          this.dialogData.title = `注意事项(${this.enterpriseInfo.individualNeeds.length})`;
          this.dialogData.buttonArray = [];
          this.dialogData.data = [
            {
              type: "address-list",
              title: "",
              data: this.enterpriseInfo.individualNeeds,
            },
          ];
          this.dialogData.flag = true;
          break;
        // 查看集团主公司
        case "group":
          window.open("#/enterprise?eid=" + item.eid);
          break;
        case "client":
          this.$emit("showClientDrawer");
          break;
        case "contract":
          this.$emit("showContractDrawer");
          break;
        // 查看全部企业标签
        case "companyTags":
          this.dialogData.width = "700px";
          this.dialogData.title = `企业标签(${this.enterpriseInfo.companyTags.length})`;
          this.dialogData.buttonArray = [];
          this.dialogData.data = [
            {
              type: "tag-list",
              title: "",
              data: this.enterpriseInfo.companyTags,
            },
          ];
          this.dialogData.flag = true;
          break;
        case "makesure_relevance":
          requestData = {
            clientId: this.clientInfo.id, // 当前客户
            relevanceClient: [this.dialogData.data[0].value], // 要关联的客户数组
          };
          this.$request(
            "post",
            "/client/setRelevanceClientByClientId",
            requestData,
            (data) => {
              this.dialogData.flag = false;
              this.$message.success("手动关联客户成功!");
              this.showRelevanceClient();
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        case "cancel":
          this.colseDialog();
          break;
        default:
          break;
      }
    },
    // 获取企业关联公司
    getCompanyList(pageData) {
      let requestData = {
        pid: this.enterpriseInfo.base.frPersonId,
        pageIndex: pageData.pageIndex,
        pageSize: pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_4590",
        requestData,
        (data) => {
          data.personInfo.relationCompanies.data.forEach((item) => {
            // 处理省市县
            item.areaList = `${item.regorgProvince}-${item.regorgCity}-${item.regorgCounty}`;
            // 处理注册资本
            item.regcapStr = item.regcap + "万";
            // 处理经营状态
            item.companyStatusNameStr = allClientData.companyStatus(
              item.companyStatusName,
            );
            // 处理持股比例
            item.fundedRatioNumStr = this.NumberToPercentage(
              item.fundedRatioNum,
            );
          });
          this.dialogData.data = [
            {
              type: "table-enterprise",
              title: "",
              data: {
                type: "companyList",
                tableMenu: allClientData.enterpriseByCompanyList(),
                tableData: data.personInfo.relationCompanies.data,
                pageData: {
                  pageIndex: data.personInfo.relationCompanies.pageIndex, // 当前页数
                  totalCount: data.personInfo.relationCompanies.totalCount, // 总条目数
                  pageSize: data.personInfo.relationCompanies.pageSize, // 每页条数
                },
              },
              value: "",
            },
          ];
          this.dialogData.flag = true;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    pageChange(componentData) {
      switch (componentData.type) {
        case "companyList":
          this.getCompanyList(componentData.pageData);
          break;
        default:
          break;
      }
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
    // 数字转为百分比
    NumberToPercentage(value) {
      const num = parseFloat(value);
      let percentage;
      if (num === 0) {
        percentage = "0%";
      } else if (num >= 0.1) {
        percentage = `${Math.round(num * 100)}%`;
      } else {
        percentage = `${(num * 100).toFixed(2)}%`;
      }
      return percentage;
    },
    // 企业官网跳转
    link(url) {
      window.open(url, "_blank");
    },
    entAnYears(data) {
      let list = data.map((item) => {
        return {
          name: item.ancheYear + "年度",
        };
      });
      this.tab3.active = data[0].ancheYear + "年度";
      this.tab3.list = list;
    },
    changeActiveCount(data) {
      // console.log("data", data);
      if (this.tab1.active == "经营信息" || this.tab1.active == "联系方式") {
        // 没有三级菜单 修改二级菜单数量
        this.tab2.list.forEach((item) => {
          if (item.name == data.tab2Active) {
            console.log("item", item);
            if (data.count > 0) {
              this.$set(item, "count", data.count);
            } else {
              this.$set(item, "disabled", true);
            }
          }
        });
      } else {
        this.tab3.list.forEach((item) => {
          if (item.name == data.tab3Active) {
            if (data.count > 0) {
              this.$set(item, "count", data.count);
            } else {
              this.$set(item, "disabled", true);
            }
          }
        });
      }
    },
    // 关闭抽屉
    closeDrawer() {
      this.$emit("closeDrawer");
    },
    refreshClientData() {
      // 获取企业注意事项
      this.getIndividualNeeds();
      // 获取crm客户信息
      this.getClientInfo();
      // 获取日程模板实例
      this.getServiceTemplateInstance();
      // 获取日程列表
      this.getScheduleList();
      // 获取关联客户
      this.showRelevanceClient();
    },
    /**
     * 查看关联客户
     */
    showRelevanceClient() {
      let requestData = {
        userId: this.baseInfo.userId,
        clientId: this.clientInfo.id, // 当前客户
      };
      this.$request(
        "post",
        "/client/getAllRelevanceClientListByClientId",
        requestData,
        (data) => {
          this.gridData = data;
          this.badge = data.length;
        },
      );
    },
    /**
     * 关联方式名称集合（同一客户可能同时存在多种关联）
     */
    getRelationTypeNames(row) {
      if (row.relationTypeNames && row.relationTypeNames.length) {
        return row.relationTypeNames;
      }
      if (row.relationTypeName) {
        return [row.relationTypeName];
      }
      return ["关联"];
    },
    /**
     * 关联方式标签颜色：经营关联-警告色，老板关联-成功色，介绍关联-信息色
     */
    relationTagType(index, row) {
      const types = row.relationTypes || [];
      const type = types[index] || row.relationType;
      if (type === "2" || type === "3") return "warning";
      if (type === "1") return "success";
      if (type === "4") return "info";
      return "";
    },
    /**
     * 关联内容（手机号、发票上下游依据等）
     */
    getRelationContents(row) {
      if (row.relationContents && row.relationContents.length) {
        return row.relationContents;
      }
      return ["-"];
    },
    /**
     * 财税顾问（服务顾问角色）
     */
    formatConsultants(row) {
      if (row.consultantNames && row.consultantNames.length) {
        return row.consultantNames.join("、");
      }
      return "-";
    },
    /**
     * 服务状态（仅客户状态：正常/待流失审核/已流失）
     */
    getStatusList(row) {
      if (row.clientStatusName) {
        return [row.clientStatusName];
      }
      if (row.statusList && row.statusList.length) {
        return [row.statusList[0]];
      }
      return ["-"];
    },
    statusTagType(status) {
      if (status === "正常") return "success";
      if (status === "待流失审核") return "warning";
      if (status === "已流失") return "info";
      return "";
    },
    /**
     * 仅介绍关联（手动维护）允许解除，老板/经营关联为系统自动计算
     */
    canRemoveRelevance(row) {
      if (row.relationType) {
        return row.relationType === "4";
      }
      return (row.relationTypes || []).indexOf("4") > -1;
    },
    /**
     * 收起关联客户浮层（打开添加弹窗前调用，避免遮挡弹窗）
     */
    closeRelevancePopover() {
      const popover = this.$refs.relevancePopover;
      if (popover && typeof popover.doClose === "function") {
        popover.doClose();
      }
    },
    /**
     * 手动添加关联客户
     */
    addRelevanceClient() {
      // 先收起关联客户浮层，避免遮挡居中的添加弹窗
      this.closeRelevancePopover();
      this.dialogData.title = "添加转介绍客户";
      this.dialogData.width = "500px";
      this.dialogData.buttonArray = [];
      this.dialogData.buttonArray.push(
        {
          text: "确定",
          active: "makesure_relevance",
        },
        {
          text: "取消",
          active: "cancel",
        },
      );
      this.dialogData.data = [
        {
          title: "转介绍客户名称",
          key: "clientId",
          type: "select-filterable",
          value: [],
          placeholder: "请输入关键词以搜索客户名称",
          loading: false,
          options: [],
        },
      ];
      this.dialogData.flag = true;
    },
    /**
     * 手动删除关联客户
     */
    deleteRelevanceClient(id) {
      this.$confirm("确定解除当前关联客户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let requestData = {
            clientId: this.clientInfo.id, // 当前客户
            relevanceClientId: id,
          };
          this.$request(
            "post",
            "/client/removeRelevanceClientByClientId",
            requestData,
            (data) => {
              this.$message({
                message: "关联客户解除成功!",
                type: "success",
              });
              this.showRelevanceClient();
            },
          );
        })
        .catch(() => {});
    },
    remoteMethod2(data) {
      this.getClientByQuery(data);
    },
  },
  created() {
    if (this.type == "client") {
      this.tab1 = allClientData.enterpriseTobList();
    } else if (this.type == "compliance") {
      this.tab1 = allClientData.enterpriseComplianceList();
    }
  },
  mounted() {
    if (this.$route.query.eid) {
      this.client.clientName = this.$route.query.eid;
    } else {
      this.client = this.clientInfo;
    }
    this.tab1.list.forEach((item) => {
      if (item.name == "档案" && !this.client.id) {
        item.disabled = true;
      }
      if (item.name == "云盘" && !this.client.id) {
        item.disabled = true;
      }
    });
    this.scheduleData.date = [
      this.$dayjs().subtract(1, "month").format("YYYY-MM"),
      this.$dayjs().add(1, "month").format("YYYY-MM"),
    ];
    this.tab2 = allClientData.enterpriseTabList(this.tab1.active);
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getOtherTab();
    this.getUserAuthorityByModels();
    this.getBaseInfo();
  },
};
</script>

<style lang="less" scoped>
#enterprise {
  width: 100%;
  height: 100%;
  overflow: auto;
  font-family: PingFangSC-Regular;
  &::-webkit-scrollbar {
    display: none;
  }
  .enterprise-title {
    width: 100%;
    .base_header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 24px;
      background-color: #fff;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 4px 4px 0 0;
      background-image: url(https://51nbimg.u51.com/e557dd67e4fd4c238b66d18dba344556.png);
      .base_header_left {
        display: flex;
        flex: 1;
        align-items: center;
        overflow: hidden;
        .base_header_left_logo {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 80px;
          height: 80px;
          background-color: #fff;
          border-radius: 4px;
          background-color: rgba(255, 130, 0, 0.1);
          color: rgb(255, 130, 0);
          font-size: 24px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }
        .base_header_left_text {
          display: flex;
          flex: 1;
          flex-direction: column;
          align-items: flex-start;
          margin-left: 12px;
          overflow: hidden;
          .company_name {
            display: flex;
            margin-top: 6px;
            color: var(--xlb-gray-10);
            font-weight: 500;
            font-size: 22px;
            line-height: 22px;
            .invoice {
              display: flex;
              align-items: center;
              margin-left: 12px;
              padding-left: 12px;
              font-size: 14px;
              font-weight: 400;
              // line-height: 14px;
              border-left: 1px solid #dee2ec;
              cursor: pointer;
              img {
                width: 16px;
                height: 16px;
                margin-right: 4px;
              }
              i {
                color: #327bf9;
                margin-right: 5px;
              }
            }
          }
          .company_tags {
            display: flex;
            align-items: center;
            margin-top: 8px;
            .company_tags_item {
              color: rgb(255, 130, 0);
              background: rgb(255, 247, 230);
              font-size: 12px;
              padding: 3px 4px;
              margin-right: 4px;
            }
          }
        }
      }
      .base_header_right {
        .base_header_right_client {
          i {
            cursor: pointer;
          }
        }
      }
    }
    .base_info {
      width: 100%;
      padding: 16px 24px;
      background-color: #fff;
      border-bottom: 16px solid #f9fafc;
      box-sizing: border-box;
      .base_info_item {
        display: flex;
        align-items: center;
        overflow: hidden;
        font-size: 14px;
        font-weight: 400;
        line-height: 25px;
        .base_info_item_title {
          color: #777e95;
          white-space: nowrap;
          margin-right: 5px;
        }
        .base_info_item_value {
          display: flex;
          white-space: nowrap;
          color: #111a34;
          overflow: hidden;
          .tag {
            font-size: 13px;
            height: 22px;
            line-height: 22px;
            color: #7c89a3;
            border-radius: 2px;
            padding: 0px 4px;
            margin-right: 8px;
            background: #f5f8ff;
          }
        }
      }
      .base_info_group {
        display: flex;
        align-items: center;
        padding-top: 12px;
        margin-top: 10px;
        border-top: 1px solid #eff1f8;
        .base_info_group_item {
          display: flex;
          align-items: center;
          overflow: hidden;
          font-size: 14px;
          font-weight: 400;
          padding-left: 12px;
          margin-left: 12px;
          border-left: 1px solid #dee2ec;
          .base_info_group_item_title {
            color: #777e95;
            margin-right: 5px;
          }
          .base_info_group_item_value {
            color: #111a34;
          }
          &:first-child {
            padding-left: 0;
            margin-left: 0;
            border-left: none;
          }
        }
      }
    }
  }
  .enterprise-schedule {
    border-bottom: 16px solid #f9fafc;
  }
  .enterprise-info {
    position: relative;
    width: 100%;
    background-color: #fff;

    .tabs-nav-list {
      position: sticky;
      top: 0;
      background-color: #fff;
      padding-bottom: 5px;
      padding: 24px;
      z-index: 99;
      box-sizing: border-box;
      .tabs-nav-list-1 {
        .el-tab-pane {
          display: flex;
          font-size: 16px;
          img {
            width: 20px;
            height: 20px;
            margin-right: 2px;
            vertical-align: text-bottom;
          }
        }
      }
      .tabs-nav-list-2 {
        display: flex;
        flex-wrap: wrap;
        .tabs-nav-list-2-item {
          font-size: 14px;
          color: #777e95;
          padding-right: 16px;
          margin-right: 16px;
          border-right: 1px solid #dee2ec;
          cursor: pointer;
          white-space: nowrap;
          &:last-child {
            border-right: none;
          }
        }
        .is-active {
          color: #327bf9;
          // font-weight: 500;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
      .tabs-nav-list-3 {
        display: flex;
        flex-wrap: wrap;
        margin: 12px 0;
        .tabs-nav-list-3-item {
          font-size: 14px;
          color: #777e95;
          cursor: pointer;
          height: 28px;
          padding: 0 12px;
          line-height: 28px;
          cursor: pointer;
          border-radius: 14px;
          white-space: nowrap;
        }
        .is-active {
          color: #327bf9;
          background: #eaf2ff;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
    }
    .enterprise-info-content {
      width: 100%;
      min-height: 1000px;
      padding: 0 24px;
      box-sizing: border-box;
    }
  }
  .activeColor {
    color: #327bf9 !important;
    cursor: pointer;
  }
  /deep/ .el-tabs {
    .el-tabs__item {
      color: #777e95;
    }
    .is-active {
      color: #409eff;
    }
    .is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
  /deep/ .el-input__inner {
    width: 100% !important;
    border: 1px solid #dcdfe6;
  }
}
</style>
